import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { CHUNK_RELOAD_FLAG } from './app/core/providers/error-handler/chunk-reload-error-handler';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    // The app loaded cleanly, so any earlier chunk-load recovery is resolved.
    // Clear the guard so a future stale-bundle error can trigger a reload again.
    try {
      globalThis.sessionStorage?.removeItem(CHUNK_RELOAD_FLAG);
    } catch {
      // Ignore — sessionStorage may be unavailable.
    }
  })
  .catch(err => console.error(err));
